import { useMutation } from "react-query";
import AG from "elements/AG";
import { useHistory } from "react-router-dom";
import { dateFormmaterNoTime } from "global/helpers";
import * as AppUrls from "constants/AppUrls";
import { getRmaList } from "./Services/adminServices";
import { returnEnum, RMAStatus } from "./StatusEnum";
import DispatchContext from "context/DispatchContext";
import exportIcon from "img/export.svg";
import AgGrid from "elements/AgGrid";
import { useContext, useEffect, useState } from "react";
export default function RmaList() {
  const appDispatch = useContext(DispatchContext);
  const history = useHistory();
  const [filters, setFilters] = useState({
    searchQuery: "",
  });
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const dataMutation = useMutation("data", getRmaList);

  const columns = [
    {
      field: "rmaNumber",
      headerName: "RMA",
      resizable: true,
    },
    {
      field: "rmaDate",
      headerName: "RMA Date",
      cellRenderer: (params) =>
        params.value ? `${dateFormmaterNoTime(params.value)}` : "",
      resizable: true,
    },
    {
      field: "returnMethod",
      headerName: "Return Method",
      resizable: true,
      cellRenderer: (params) => returnEnum[params.value],
    },
    {
      field: "orderNumber",
      headerName: "Order No",
      resizable: true,
    },
    {
      field: "itemsToReturn",
      headerName: "Items to return",
      resizable: true,
    },
    {
      field: "status",
      headerName: "Status",
      cellRenderer: (params) => RMAStatus[params.value],
      resizable: true,
    },
    {
      field: "creditMemo",
      headerName: "CM",
      resizable: true,
    },
  ];

  const onRowClick = (e) => {
    let url = `${AppUrls.ecommerce_rma}/${e.rmaId}`;
    history.push(url);
  };

  const [dataGrid, setDataGrid] = useState(null);
  const [exportToExcelClicked, setExportToExcelClicked] =
    useState<boolean>(false);
  const [disabledExportBtn, setDisabledExportBtn] = useState<boolean>(false);
  const [isLoadingGridExport, setIsLoadingGridExport] =
    useState<boolean>(false);

  const exportToExcel = () => {
    dataMutation.mutate(null, {
      onSuccess(result) {
        setDataGrid(result.data);
      },
    });
  };

  useEffect(() => {
    if (dataGrid && dataGrid.length > 0) {
      if (dataMutation.isSuccess) {
        setIsLoadingGridExport(true);
        setDisabledExportBtn(true);
        setExportToExcelClicked(true);
        let notification = {
          variant: "success",
          msg: "Preparing grid for export...",
        };
        appDispatch({ type: "notification", value: notification });
      }
    }
  }, [dataGrid, dataMutation.isSuccess]);

  useEffect(() => {
    appDispatch({ type: "loading", value: isLoadingGridExport });
  }, [appDispatch, isLoadingGridExport]);

  const onSearchTermChange = (e) => {
    const value = e?.target?.value;
    setSearchTerm(value);

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const newDebounceTimeout = setTimeout(() => {
      setFilters((filters) => ({ ...filters, searchQuery: value }));
      setDataGrid(null);
    }, 1000);

    setDebounceTimeout(newDebounceTimeout);
  };

  return (
    <div className="grid-page">
      <div className="page-title page-title-editable">
        <p>RMA</p>
        <button
          className="import-btn"
          type="button"
          onClick={exportToExcel}
          disabled={disabledExportBtn || dataGrid?.length === 0}
        >
          <img src={exportIcon} className="me-2" alt="" />
          Export to Excel
        </button>
      </div>
      <div className="page-content-wrapper">
        <div className="filters">
          <div className="form-group">
            <label className="me-2">Search</label>
            <div className="page-search">
              <div className="input-group">
                <span className="page-search-icon">
                  <i className="fa fa-search"></i>
                </span>
                <input
                  className="page-search-input ps-5 me-4 w-200"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => onSearchTermChange(e)}
                  value={searchTerm}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="grid-container">
          <AgGrid
            columns={columns}
            fetchMethod={dataMutation}
            data={dataGrid}
            filters={filters}
            setDataGrid={setDataGrid}
            setrowClicked={onRowClick}
            exportToExcel={exportToExcelClicked}
            setExportToExcelClicked={setExportToExcelClicked}
            setDisabledExportBtn={setDisabledExportBtn}
            setIsLoadingGridExport={setIsLoadingGridExport}
            fileName="RMA List Report"
          />
        </div>
      </div>
    </div>
  );
}
